export {
  ViewJobTasksComponent,
} from './project-tasks/view-job-tasks.component';